import { WORDPRESS_API } from "shared/constants/api";

export const tendersDocuments = [
  {
    id: "pracownia-gastronomiczna",
    title: "Przygotowanie dokumentacji projektowej pracowni gastronomicznej",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Zapytanie-ofertowe-CKZiU-w-Wyrzysku.pdf`
  }
];